<template>
  <Day day="11.12.2025">
    <div slot="page-content">
      <h3>Nature vibes</h3>
      <p>
        <img src="@/assets/day11.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day11',
  components: {
    Day
  }
}
</script>
